define('modules/layout/nav',['require','jquery','underscore','evertrue','react','et_flux','models/FeaturesModel','modules/affiliation-requests/stores/affiliation-request-store','modules/affiliation-requests/sources/affiliation-request-source'],function(require) {
  var $, AffiliationRequestSource, AffiliationRequestStore, EverTrue, FeaturesModel, MARKET_RESOURCES_CUTOFF, React, a, createComponent, div, i, img, li, p, span, ul, _, _ref;
  $ = require("jquery");
  _ = require("underscore");
  EverTrue = require("evertrue");
  React = require("react");
  createComponent = require("et_flux").createComponent;
  FeaturesModel = require("models/FeaturesModel");
  AffiliationRequestStore = require("modules/affiliation-requests/stores/affiliation-request-store");
  AffiliationRequestSource = require("modules/affiliation-requests/sources/affiliation-request-source");
  _ref = React.DOM, div = _ref.div, a = _ref.a, img = _ref.img, ul = _ref.ul, li = _ref.li, p = _ref.p, i = _ref.i, span = _ref.span;
  MARKET_RESOURCES_CUTOFF = 439;
  return createComponent("Nav", {
    getInitialState: function() {
      return {
        features: [],
        login_request_count: 0,
        active_path: void 0
      };
    },
    registerStores: function() {
      return this.on(AffiliationRequestStore, function() {
        return {
          has_pending_requests: AffiliationRequestStore.getHasPendingRequests()
        };
      });
    },
    componentDidMount: function() {
      var features, _ref1;
      if (this.isMounted()) {
        this.setState({
          active_path: Backbone.history.location.pathname
        });
      }
      features = new FeaturesModel();
      if (this.isMounted()) {
        this.setState({
          features: features != null ? (_ref1 = features.defaults) != null ? _ref1.features : void 0 : void 0
        });
      }
      features.on("change", (function(_this) {
        return function() {
          var _ref2;
          if (_this.isMounted()) {
            return _this.setState({
              features: features != null ? (_ref2 = features.toJSON()) != null ? _ref2.features : void 0 : void 0
            });
          }
        };
      })(this));
      features.init();
      AffiliationRequestSource.checkHasPendingRequests();
      return EverTrue.vent.on("route:change", (function(_this) {
        return function() {
          if (_this.isMounted()) {
            return _this.setState({
              active_path: Backbone.history.location.pathname
            });
          }
        };
      })(this));
    },
    componentDidUpdate: function(prevProps, prevState) {
      if (!_.isEqual(prevState.has_pending_requests, this.state.has_pending_requests) && this.state.has_pending_requests) {
        return this.loadLoginRequestPopover();
      }
    },
    loadLoginRequestPopover: function() {
      var _ref1;
      return (_ref1 = $(".js-login-request-hover")) != null ? _ref1.popover({
        html: true,
        trigger: "manual",
        container: "body",
        placement: "right",
        title: "<strong>Pending Login Requests</strong>" + "<button type=\'button\' class=\'js-popover-close close\'>&times</button>",
        content: "<div class=\'clearfix\'>" + "<p>You have users waiting to get in.</p>" + "<a class=\'btn btn-primary pull-left\' href=\'/dashboard/requests\'>Help them get in!</a>" + "<button class=\'btn pull-right js-popover-close\'>Ignore</button>" + "</div>",
        offset: 10,
        template: "<div class='popover' onmouseover='$(this).mouseleave(function() {$(this).hide();});'><div class'arrow'></div><div class='popover-inner'><h3 class='popover-title'></h3><div class='popover-content'><p></p></div></div></div>"
      }).mouseenter(function(e) {
        $(this).popover("show");
        return $(".js-popover-close").click((function(_this) {
          return function() {
            return $(_this).popover("hide");
          };
        })(this));
      }).mouseleave(function(e) {
        return setTimeout(((function(_this) {
          return function() {
            if (!$(".popover:hover").length) {
              return $(_this).popover("hide");
            }
          };
        })(this)), 100);
      }) : void 0;
    },
    handleLogout: function() {
      return EverTrue.logout({
        killPrimeToken: true
      });
    },
    renderNavItem: function(feature, url, name, icon) {
      var activeClass, path, _ref1;
      if (!_.contains(this.state.features, feature)) {
        return;
      }
      if (url === "/app/content/social") {
        path = "/app/content";
      } else if (url === "/app/design/main_color") {
        path = "/app/design";
      } else if (url === " /dashboard/growth/resources") {
        path = "/dashboard/growth";
      } else {
        path = url;
      }
      activeClass = ((_ref1 = this.state.active_path) != null ? _ref1.indexOf(path) : void 0) >= 0 ? "active" : "";
      return li({
        className: activeClass,
        key: name
      }, a({
        className: "tour-" + feature,
        href: url
      }, i({
        "aria-hidden": true,
        className: "menu-icon fa " + icon
      }), name, url.indexOf("dashboard/requests") >= 0 && this.state.has_pending_requests ? span({
        className: "js-login-request-hover count-circle"
      }, "NEW") : void 0));
    },
    render: function() {
      var year;
      year = new Date();
      year = year.getFullYear();
      return div({
        className: "side-nav side-nav-left"
      }, div({
        className: "auth-status"
      }, div({
        className: "media"
      }, div({
        className: "avatar"
      }, img({
        src: EverTrue.User.getAvatar()
      })), div({
        className: "content"
      }, div({
        className: "avatar-name"
      }, EverTrue.User.get("name")), a({
        className: "logout",
        href: "javascript:;",
        onClick: this.handleLogout
      }, "Logout")))), ul({
        className: "nav nav-side clearfix"
      }, li({
        className: "nav-header"
      }, "Administration"), this.renderNavItem("reporting", "/dashboard/reporting", "Reporting", "fa-bar-chart-o"), this.renderNavItem("manage_records", "/person/manage/search", "Constituent Records", "fa-files-o"), this.renderNavItem("users", "/dashboard/users", "Existing Users", "fa-user"), this.renderNavItem("login_requests", "/dashboard/requests", "New User Requests", "fa-user"), this.renderNavItem("importer", "/data/importer", "Import", "fa-upload"), this.renderNavItem("notifications", "/app/notifications", "Notifications", "fa-envelope-o"), this.renderNavItem("flex_data", "/data/flex", "Configure Custom Fields", "fa-asterisk"), EverTrue.Organization.hasProduct("community") ? li({
        className: "nav-header"
      }, "App Setup") : void 0, this.renderNavItem("setup", "/app/setup", "Setup", "fa-cogs"), this.renderNavItem("design", "/app/design/main_color", "Design", "fa-picture-o"), this.renderNavItem("content", "/app/content/social", "Content", "fa-list-alt"), EverTrue.Organization.get("id") < MARKET_RESOURCES_CUTOFF ? this.renderNavItem("growth", "/dashboard/growth/resources", "Marketing Resources", "fa-arrow-circle-o-up") : void 0, EverTrue.User.get("super_user") ? li({
        className: "nav-header"
      }, "EverTrue Admins") : void 0, this.renderNavItem("settings", "/admin/settings", "Settings", "fa-cog"), this.renderNavItem("user_mgmt", "/admin/manage-users", "Admin User Management", "fa-users"), this.renderNavItem("dna_editor", "/admin/dna-editor", "DNA Editor", "fa-warning"), this.renderNavItem("roles", "/data/roles", "Roles", "fa-sitemap"), li({
        className: "nav footer"
      }, p(null, "EverTrue © " + year))));
    }
  });
});

//# sourceMappingURL=nav.js.map
;
